import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for ChatStore, for use in the registry */ export const ChatStoreActionTypes = [
    ActionType.FetchEntityAction,
    ActionType.FetchEntityFailedAction,
    ActionType.FetchEntitySucceededAction,
    ActionType.DeltaSyncAction,
    ActionType.DeltaSyncSucceededAction,
    ActionType.DeltaSyncFailedAction,
    ActionType.CreateEntityAction,
    ActionType.CreateEntityFailedAction,
    ActionType.CreateEntitySucceededAction,
    ActionType.UpdateEntityAction,
    ActionType.UpdateEntityFailedAction,
    ActionType.UpdateEntitySucceededAction,
    ActionType.FetchEntityCollectionAction,
    ActionType.FetchEntityCollectionFailedAction,
    ActionType.FetchEntityCollectionSucceededAction,
    ActionType.DeleteChatMessageAction,
    ActionType.DeleteChatMessageFailedAction,
    ActionType.DeleteChatMessageSucceededAction,
    ActionType.FetchEmojiMetadataSucceededAction,
    ActionType.FetchEmojiMetadataFailedAction,
    ActionType.MarkChatTaskPendingRefreshAction,
    ActionType.SetChatComposeDraftAction,
    ActionType.ClearChatComposeDraftAction
];
